"use strict";
exports.__esModule = true;
//# sourceMappingURL=counter.type.js.map